import Vue from "vue";
import axios from "axios";
import router from "@/router/index";
import AlertFZ from "../common/js/AlertFZ";
import "vue-layer-mobile/need/layer.css";
import layer from "vue-layer-mobile";
Vue.use(layer);
axios.defaults.baseURL = window.global_config.BASE_URL
axios.interceptors.request.use(config => {
    if (config.url.indexOf('upload/fileupload') != -1) {
        config.baseURL = window.global_config.BASE_UPDATA
    }
    if (JSON.parse(localStorage.getItem("user_xinxi"))) {
        //判断浏览器中的cookie中是否存在项目的token
        config.headers.token = JSON.parse(localStorage.getItem("user_xinxi")).token
    }
    return config
}, err => {
    return Promise.reject(err); //请求错误处理
})
axios.interceptors.response.use(response => {
    if (response.data.status == 400) {
        AlertFZ.AlertMsg("登录过期请重新登录");
        layer.close();
        router.push('/loginMima')
        return
    } else if (response.data.status == 500 && !(response.config.url.indexOf('pay/wxorder') != -1) && !(response.config.url.indexOf('buyer/visits') != -1) && !(response.config.url.indexOf('buyer/viewPage') != -1) && !(response.config.url.indexOf('zfbWap/zfbOrder') != -1) && !(response.config.url.indexOf('order/order') != -1)) {
        AlertFZ.AlertMsg(response.data.message);
    }
    return Promise.resolve(response);
}, err => {
    return Promise.reject(err);
})
var myAjax = {
    get(url) {
        return new Promise((resolve, reject) => {
            axios.get(url).then(res => { resolve(res) }).catch(err => { reject(err) });
        })
    },
    post(url, params) {
        return new Promise((resolve, reject) => {
            axios.post(url, params).then(res => { resolve(res) }).catch(err => { reject(err) });
        });
    },
    delete(url, params) {
        return new Promise((resolve, reject) => {
            axios.delete(url, params).then(res => { resolve(res) }).catch(err => { reject(err) });
        })
    },
    put(url, params) {
        return new Promise((resolve, reject) => {
            axios.put(url, params).then(res => { resolve(res) }).catch(err => { reject(err) });
        })
    },
    postZib(url, params) {
        return new Promise((resolve, reject) => {
            axios({
                method: "post",
                responseType: 'blob',
                url,
                data: params
            }).then(res => { resolve(res) }).catch(err => { reject(err) });
        })
    },
}
export default myAjax


// WEBPACK FOOTER //
// ./src/axios/http.js